import { TooltipTrigger } from "@visiblethread/react-components";
import Flex, { ALIGN_CLASS, GAP_CLASS } from "components/Flex";
import { sumBy } from "lodash";
import { arrayOf, bool, number, oneOfType, shape, string } from "prop-types";
import React from "react";

import styles from "./StatusBar.module.scss";

const MIN_LABEL_PCT = 9;
const TOOLTIP_DELAY = 1000;
const DEFAULT_UNIT_LABEL = "item";

const StatusBar = ({ segments, total, unitLabel = DEFAULT_UNIT_LABEL, testId }) => {
  const safeTotal = Math.max(total ?? sumBy(segments, "count"), 1);

  return (
    <Flex className={styles.statusBar} data-testid={testId && `${testId}-bar`}>
      {segments
        .filter((segment) => segment.count > 0)
        .map(({ key, label, color, count, showLabel = true }) => {
          const widthPct = (count / safeTotal) * 100;
          const roundedPct = Math.round((count / safeTotal) * 100);

          return (
            <TooltipTrigger
              content={
                <Flex
                  alignItems={ALIGN_CLASS.center}
                  gap={GAP_CLASS.GAP_100}
                  className={styles.statusBar__tooltipContent}
                >
                  <span
                    className={styles.statusBar__tooltipDot}
                    style={{ backgroundColor: color }}
                  />
                  <strong>{label}</strong>
                  <span>
                    {count} {unitLabel}
                    {count === 1 ? "" : "s"} &middot; {roundedPct}%
                  </span>
                </Flex>
              }
              classes={styles.statusBar__segment}
              data-testid={testId && `${testId}-segment-${key}`}
              delay={TOOLTIP_DELAY}
              key={key}
              maxWidth="none"
              placement="top"
              style={{
                backgroundColor: color,
                width: `${widthPct}%`,
              }}
            >
              {showLabel && widthPct >= MIN_LABEL_PCT && (
                <span className={styles.statusBar__segmentLabel}>{count}</span>
              )}
            </TooltipTrigger>
          );
        })}
    </Flex>
  );
};

StatusBar.propTypes = {
  segments: arrayOf(
    shape({
      key: oneOfType([string, number]).isRequired,
      label: string.isRequired,
      color: string.isRequired,
      count: number.isRequired,
      showLabel: bool,
    })
  ).isRequired,
  total: number,
  unitLabel: string,
  testId: string,
};

export default StatusBar;
